module.exports = __webpack_public_path__ + "img/app-pillars-2.619539b0.png";